import { FEATURE_FLAGS } from 'dashboard/featureFlags';
import { frontendURL } from 'dashboard/helper/URLHelper';
import FlowListPage from 'flow_builder/pages/FlowListPage.vue';
import FlowEditorPage from 'flow_builder/pages/FlowEditorPage.vue';
import FlowExecutionsPage from 'flow_builder/pages/FlowExecutionsPage.vue';
import FlowReportsPage from 'flow_builder/pages/FlowReportsPage.vue';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/flow'),
    component: FlowListPage,
    name: 'flow_list',
    meta: {
      permissions: ['administrator'],
      // Note: No featureFlag here - the page handles displaying a disabled state
    },
  },
  {
    path: frontendURL('accounts/:accountId/flow/:flowId/editor'),
    component: FlowEditorPage,
    name: 'flow_editor',
    meta: {
      permissions: ['administrator'],
      featureFlag: FEATURE_FLAGS.FLOW,
    },
  },
  {
    path: frontendURL('accounts/:accountId/flow/:flowId/executions'),
    component: FlowExecutionsPage,
    name: 'flow_executions',
    meta: {
      permissions: ['administrator'],
      featureFlag: FEATURE_FLAGS.FLOW,
    },
  },
  {
    path: frontendURL('accounts/:accountId/flow/:flowId/reports'),
    component: FlowReportsPage,
    name: 'flow_reports',
    meta: {
      permissions: ['administrator'],
      featureFlag: FEATURE_FLAGS.FLOW,
    },
  },
];
